export const CarrierSharingConfigurationType = Object.freeze({
  Default: 'Default',
  Custom: 'Custom',
});

export const CarrierSharingPartnerType = Object.freeze({
  Vendor: 'Vendor',
  FulfillmentProvider: 'FulfillmentProvider',
});
